import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["input"]
    static values = {range: Number}

    connect() {
        this.initZebra()
    }

    initZebra() {
        if (this.inputTarget) {
            let params = zebra_options // getting zebra_options from app/views/layouts/_layout.haml
            if (this.hasRangeValue) {
                params['direction'] = [true, this.rangeValue]
            }
            // console.log('zebrarize', this.inputTarget)
            $(this.inputTarget).Zebra_DatePicker(params)
        }
    }
}
